/** In-app navigation for code outside React's tree (toast actions): the router's navigate while the app shell is mounted, a page load otherwise. */
type Navigate = (to: string) => void;

let current: Navigate | null = null;

/** The app shell registers the router's navigate; the returned function unregisters it. */
export function registerNavigate(fn: Navigate): () => void {
  current = fn;
  return () => {
    if (current === fn) current = null;
  };
}

export function go(to: string) {
  if (current) current(to);
  else window.location.assign(to);
}
